import { Button } from 'react-bootstrap';
import { useAdminAccess } from '../contexts/AdminAccessData';
import { useSessionData } from '../contexts/SessionData';

/**
 * AdminDestinationChooser
 *
 * Lists only destinations granted by the App-owned access response. Receives
 * a navigation callback and optionally limits choices to restaurants. It uses
 * the shared session language and performs no requests or navigation itself.
 */
export default function AdminDestinationChooser({ onSelect, restaurantsOnly = false }: {
  onSelect: (path: string) => void;
  restaurantsOnly?: boolean;
}) {
  const admin = useAdminAccess();
  const session = useSessionData();
  const language = session?.lang ?? 'en';
  return <div className="d-grid gap-2" aria-label="Admin destinations">
    {admin?.access?.restaurants.map((restaurant) =>
      <Button key={restaurant.food_maker_key} variant="outline-success"
        onClick={() => onSelect(`/MenuEditing?${new URLSearchParams({
          fm: restaurant.food_maker_key, lang: language,
        }).toString()}`)}>
        {restaurant.display_name}
      </Button>)}
    {!restaurantsOnly && admin?.access?.can_view_food_makers_status &&
      <Button variant="outline-success" onClick={() => onSelect('/FoodMakersStatus')}>Food Makers Status</Button>}
  </div>;
}
